import { storeToRefs, defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'
import { useReturnCarrier } from '@/composables/returnCarrier.js'
import { useAccountStore } from '@/stores/account.js'
import { useClientStore } from '@shared/stores/client.js'
import { useClosetStore } from '@shared/stores/closet.js'

export const useFedExOptInStore = defineStore('fedExOptIn', () => {
  const {
    isSeattleLocal,
    fedexPreferred
  } = useReturnCarrier()
  const {
    getPreviousPickupConfirmationCode,
    getPickupLocations,
  } = useAccountStore()
  const { getReturnPackages } = useClientStore()
  const { showFedexSuccessModal: showSuccessModal, returnPackages } = storeToRefs(useClientStore())
  const { toReturnItems } = storeToRefs(useClosetStore())
  const recentFedexPickup = ref(null)


  async function initializeFedExInfo () {
    const { confirmationCode } = await getPreviousPickupConfirmationCode()
    recentFedexPickup.value = confirmationCode
    await getPickupLocations()
    await getReturnPackages(1)
  }

  return {
    initializeFedExInfo,
    showSuccessModal,
    fedexPreferred,
    isSeattleLocal,
    toReturnItems,
    returnPackages,
    recentFedexPickup
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useFedExOptInStore, import.meta.hot))
